import type { FaireProductEntity } from "../../entity_types/product";

export const p_499uawgc: FaireProductEntity = {
  token: "p_499uawgc",
  type: "product",
  name: "Happy Days Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/65b81ac03fc82572a1fde04a2b5591986579af6310a7be585f40ac36c48beac4/1528333805.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d64f678c3805a1446f1e98dcc222d6ce3c6775b820dfe476bce6d127cd954796/1528333805.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:55.219Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
